import gql from "graphql-tag";
import PostOrReplyAuthorFields from "./PostOrReplyAuthorFields";
import EditablePostFields from "./EditablePostFields";
import LockablePostFields from "./LockablePostFields";
import PinnablePostFields from "./PinnablePostFields";
import ReactableFields from "../ReactableFields";

export default gql`
  fragment PostFields on Post {
    _id
    shortId
    bodyAsJson
    bodyAsPlainText
    createdAt

    ... on IrpfPost {
      title
      lastRepliedAt

      ...LockablePostFields
      ...PinnablePostFields
      ...EditablePostFields
      ...ReactableFields
    }

    author {
      ...PostOrReplyAuthorFields
    }

    viewerCanViewReplies
    viewerDidAuthor
    viewerCanEdit
    viewerCanDestroy
    viewerCanReply
  }

  ${LockablePostFields}
  ${PinnablePostFields}
  ${EditablePostFields}
  ${PostOrReplyAuthorFields}
  ${ReactableFields}
`;
